import React from 'react';
import { Truck, Sparkles, Loader2 } from 'lucide-react';

export default function Login() {
  const [redirecting, setRedirecting] = React.useState(false);

  const handleLogin = () => {
    setRedirecting(true);
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
      redirectUrl,
    )}`;
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-6"
      style={{ background: 'linear-gradient(135deg, #f5f7fb 0%, #e5edff 100%)' }}
    >
      <div
        className="w-full max-w-md bg-white rounded-2xl p-8"
        style={{ border: '1px solid var(--lf-line)', boxShadow: '0 20px 50px rgba(15,23,42,.08)' }}
      >
        <div className="flex items-center gap-2 mb-6">
          <div
            className="w-10 h-10 rounded-xl flex items-center justify-center"
            style={{ background: 'var(--lf-navy)' }}
          >
            <Truck size={20} color="#60a5fa" />
          </div>
          <div>
            <div className="text-xl font-extrabold">
              Lindore <span style={{ color: 'var(--lf-blue)' }}>FreightAI</span>
            </div>
            <div className="text-xs" style={{ color: 'var(--lf-muted)' }}>
              AI-powered freight optimization
            </div>
          </div>
        </div>

        <h1 className="text-2xl font-bold mb-2">Sign in to continue</h1>
        <p className="text-sm mb-6" style={{ color: 'var(--lf-muted)' }}>
          One-click sign in with Google. New accounts get a <b>7-day free Pro trial</b> — no card required.
        </p>

        <button
          onClick={handleLogin}
          disabled={redirecting}
          className="w-full flex items-center justify-center gap-2.5 py-3 rounded-xl text-sm font-semibold"
          style={{
            background: '#ffffff',
            color: '#1f2937',
            border: '1px solid #d8dde6',
            cursor: 'pointer',
            transition: 'box-shadow 0.15s ease, transform 0.1s ease',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 2px 8px rgba(15,23,42,.08)')}
          onMouseLeave={(e) => (e.currentTarget.style.boxShadow = 'none')}
        >
          {redirecting ? (
            <>
              <Loader2 className="animate-spin" size={16} /> Redirecting…
            </>
          ) : (
            <>
              <svg width="18" height="18" viewBox="0 0 24 24">
                <path
                  fill="#4285F4"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                />
                <path
                  fill="#34A853"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="#FBBC05"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                />
                <path
                  fill="#EA4335"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                />
              </svg>
              Continue with Google
            </>
          )}
        </button>

        <div
          className="mt-6 p-3 rounded-lg text-xs"
          style={{ background: '#f8faff', color: 'var(--lf-muted)' }}
        >
          <div className="flex items-center gap-1.5 mb-1">
            <Sparkles size={12} style={{ color: 'var(--lf-blue)' }} />
            <b style={{ color: '#111827' }}>Start with 7 days of Pro, free</b>
          </div>
          Full access to GPT-5 explanations, rate negotiation chat, load board matches, and PDF
          rate confirmations for 7 days. After that, Pro features lock unless you upgrade for
          $49/mo. Maps, carrier ranking, HOS checks and persistence stay free forever.
        </div>
      </div>
    </div>
  );
}
